import React, { Component } from "react";
import { WAVE_OPTIONS, LATEST_WAVE } from "./constants/waves";
import { withRouter } from "./withRouter";
import mapboxgl from "maplibre-gl";
import { tableFromIPC } from "apache-arrow";
import { Typography,Box,Stack,Select,FormControl, InputLabel, MenuItem,TextField, CircularProgress } from "@mui/material";
import MapComponent from "./MapComponent"
import NationalVoteBar from "./NationalVoteBar"
import DownloadMetricRowsButton from "./DownloadMetricRowsButton"
import { rowsFromTable } from "./utils/arrowUtils";
import { makeHeatScale, make2pointHeatScale } from "./utils/colorUtils";
import { baseColorForLikertKey } from "./utils/styleUtils";
import { PARTY_INFO, PAST_VOTE_MAP, buildLabelsAndColors, votePickerOptions } from "./constants/partyConfig";
import { withAccess } from "./access/AccessContext";



/** Heat-map party options for this user. Coalition is a bloc aggregate — internal only. */
const heatPartyOptionsFor = (access) =>
  votePickerOptions(access?.visible_parties, { includeCoalition: !!access?.is_internal });

class NZ2026Home extends Component {
      constructor(props) {
    super(props);
    this.state = {
      geoLevel: "constituency",
      metricRows: null, 
      loading: false,
      hoverInfo: null,
      hoverInfoHeatMap: null,
      hoverAreaId: null,
      hoverAreaIdHeatMap: null,
      selectedStateBounds: null,
      selectedFeature: null,   
      geoData:props.constituencyMap,
      styleLoaded: false,
      viewState: null,
      metricRowsConst: null,
      metricRowsNational:null,
      chosenGender:null,
      chosenAge:null,
      chosenEthnicity:null,
      chosenEducation:null,
      chosenPV:null,
      chosenHeatParty: heatPartyOptionsFor(props.access)[0]?.value ?? "coalition",
      chosenHeatStyle:"change",
      waveOptions: WAVE_OPTIONS,
      waveSelect: LATEST_WAVE
    };
    
    this.mapRef1 = React.createRef();
    this.mapRef2 = React.createRef();
    this._inflight = null; 
    this._lastKey = null;
    this._lastAt = 0;

    
  }

  
  componentDidMount() {
  const run = async () => {
    await this.fetchMetrics("national", null, true);
    await this.fetchMetrics("constituency", null, true);
  };
  run();
}

   componentDidUpdate(prevProps, prevState) {
    const groupChanged      = prevProps.selectedGroupId !== this.props.selectedGroupId;
   
    const levelChanged      = prevState.geoLevel !== this.state.geoLevel;

    
    const chosenGenderChanged      = prevState.chosenGender !== this.state.chosenGender;
    const chosenAgeChanged      = prevState.chosenAge !== this.state.chosenAge;
    const chosenEthnicityChanged      = prevState.chosenEthnicity !== this.state.chosenEthnicity;
    const chosenEducationChanged      = prevState.chosenEducation !== this.state.chosenEducation;
    const waveChanged   = prevState.waveSelect !== this.state.waveSelect;
    
    const chosenGenderPVChanged      = prevState.chosenPV !== this.state.chosenPV;
    const filtersChanged = chosenGenderChanged || chosenAgeChanged || chosenEthnicityChanged ||chosenGenderPVChanged ||chosenEducationChanged||waveChanged


  
    const needRefetch = levelChanged  || groupChanged ||filtersChanged;
    if (needRefetch) {
        const run = async () => {
   // await this.fetchMetrics("constituency", null, true);
    await this.fetchMetrics(this.state.geoLevel, this.state.selectedFeature?.area_id);
    };
    run();
    }

  
    const rowsChanged  = prevState.metricRows !== this.state.metricRows;
    const geoChanged   = prevState.geoData !== this.state.geoData;
    const chosenHeatPartyChanged   = prevState.chosenHeatParty !== this.state.chosenHeatParty;
    const chosenHeatStyleChanged   = prevState.chosenHeatStyle !== this.state.chosenHeatStyle;
  
    if (geoChanged || rowsChanged || groupChanged||filtersChanged||chosenHeatPartyChanged||chosenHeatStyleChanged||waveChanged) {
      this.restyle();
    }
  
   
    
  }
  _inflightBaseline = null;
  _lastBaselineKey = null;
  _lastBaselineAt = 0;
    requestKey = (level) => {

    return `${level}`;
  };

 nationalWeightedRow(metricRows, weightKey = "turnout_1_n_sum",waveSelect) {
  const valueKeys = [
    "lab_pred_n",
    "nat_pred_n",
    "green_pred_n",
    "act_pred_n",
    "nzf_pred_n",
    "tpm_pred_n",
    "top_pred_n",
  ];

  const sums = Object.fromEntries(valueKeys.map((k) => [k, 0]));
  let weightSum = 0;

  metricRows = metricRows.filter(g => Number(g.wave) === Number(waveSelect)) || {};

  for (const row of metricRows || []) {
    const w = row?.[weightKey];
    if (typeof w !== "number" || Number.isNaN(w) || w <= 0) continue;

    weightSum += w;

    for (const k of valueKeys) {
      const v = row?.[k];
      if (typeof v === "number" && !Number.isNaN(v)) {
        sums[k] += v * w;
      }
    }
  }

  const means =
    weightSum === 0
      ? Object.fromEntries(valueKeys.map((k) => [k, null]))
      : Object.fromEntries(valueKeys.map((k) => [k, sums[k] / weightSum]));

  return [
    {
      area_id: "National",
      area_name: "National",
      ...means,
    },
  ];
}


  //main function that grabs data
    fetchMetrics = async (level, constCode, save_const_results) => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;

  const reqKey = this.requestKey(level);
  const now = Date.now();
  if (this._lastKey === reqKey && now - this._lastAt < 700) return;
  this._lastKey = reqKey;
  this._lastAt = now;


    let keysBody 
    if(level==="national"||save_const_results){
          keysBody= [
                    "nat_pred_n",
                    "lab_pred_n",
                    "act_pred_n",
                    "nzf_pred_n",
                    "green_pred_n",
                    "tpm_pred_n",
                    "top_pred_n",
                    "oth_pred_n",
                   
                    "past_vote_act",
                    "past_vote_dnv", 
                    "past_vote_green",
                    "past_vote_lab",
                    "past_vote_nat", 
                    "past_vote_nzf",
                    "past_vote_oth",
                    "past_vote_tpm",
                    "turnout_1_p",
                    "n_raked"
                  ]  
    }else{
    keysBody= [
                    "nat_pred_n",
                    "lab_pred_n",
                    "act_pred_n",
                    "nzf_pred_n",
                    "green_pred_n",
                    "tpm_pred_n",
                    "top_pred_n",
                    "oth_pred_n",
                    "past_vote_act",
                    "past_vote_dnv", 
                    "past_vote_green",
                    "past_vote_lab",
                    "past_vote_nat", 
                    "past_vote_nzf",
                    "past_vote_oth",
                    "past_vote_tpm",
                    "turnout_1_p",
                    "n_raked"
                  ]
                }
                
                
     let turnout_weight
    turnout_weight = "turnout_1_n"

    const body = {
      groupKeys: keysBody,
      filters: {
      gender: this.state.chosenGender ?? null,     
      age: this.state.chosenAge ?? null,            
      ethnicity: this.state.chosenEthnicity ?? null,
      education: this.state.chosenEducation ??null,
      vote_2023: this.state.chosenPV ?? null,     
    },
      constCode: constCode,
      turnout_weight:turnout_weight
    };
    this.setState({ loading: true });
 
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/${level}_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);

      // --- update state with both ---
      if(save_const_results){
        if(level==="national"){
          this.setState(
             { metricRowsNational: rowsMain,
               
        loading: false, })
            }else{
            this.setState(
            { metricRowsConst: rowsMain ,
               metricRows: this.state.metricRows===null ? rowsMain :this.state.metricRows,
               
        loading: false,
            })
            }
      }else{
      const  means = this.nationalWeightedRow(rowsMain, "turnout_1_n_sum", this.state.waveSelect);

           this.setState({
        metricRows: rowsMain,
        metricRowsNational:means,
        loading: false,
        
      });
      }
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ metricRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }
restyle = () => {
  const { geoData, metricRows } = this.state;

  if (!geoData) {
    this.setState({ styledGeo: null, styledGeoHeatMap: null });
    return;
  }
  if (!metricRows) {
    return;
  }

  const currentWave = Number(this.state.waveSelect);
  const prevWave = currentWave - 1;

  const pastVoteCols = [
    "past_vote_act",
    "past_vote_green",
    "past_vote_lab",
    "past_vote_nat",
    "past_vote_nzf",
    "past_vote_oth",
    "past_vote_tpm",
  ];

  // Normalise values within each row so these columns sum to 100
  const normalisedRows = metricRows.map((row) => {
    const sum = pastVoteCols.reduce((acc, col) => acc + (parseFloat(row[col]) || 0), 0);
    if (sum > 0) {
      const newRow = { ...row };
      for (const col of pastVoteCols) {
        newRow[col] = ((parseFloat(row[col]) || 0) / sum) * 100;
      }
      return newRow;
    }
    return row;
  });

  // Current wave lookup
  const currentRows = normalisedRows.filter((r) => Number(r.wave) === currentWave);
  const byId = new Map();
  for (const r of currentRows) {
    const id = String(r.area_id ?? "");
    if (id) byId.set(id, r);
  }

  // Previous wave lookup
  const prevById = new Map();
  if (prevWave >= 1) {
    const prevRows = normalisedRows.filter((r) => Number(r.wave) === prevWave);
    for (const r of prevRows) {
      const id = String(r.area_id ?? "");
      if (id) prevById.set(id, r);
    }
  }

  const { labels, colors } = buildLabelsAndColors(PARTY_INFO);

  const groupKeys = [
    "nat_pred_n",
    "lab_pred_n",
    "act_pred_n",
    "nzf_pred_n",
    "green_pred_n",
    "tpm_pred_n",
                    "top_pred_n",
    "oth_pred_n",
  ];

  const noDataProps = {
    fillColor: "#ffffff",
    topLabel: "No data",
    topValue: 0,
    _allValues: {},
    _allValuesSorted: [],
    _diffValues: {},
    _diffValuesSorted: [],
    _diffTurnout: null,
    _hasPrevWave: prevWave >= 1 && prevById.size > 0,
  };

  // Helper to build entries, diffs, and pastVoteValues for a row
  const buildFeatureProps = (f, row, prevRow, fillColor, topKey, topLabel, topValue) => {
    const displayKeys = groupKeys.filter((k) => k in row);
    if (displayKeys.length === 0) {
      return { ...f, properties: { ...f.properties, ...noDataProps } };
    }

    const entries = displayKeys
      .map((k) => ({ key: k, area_name: labels[k] || k, area_id: Number(row[k]) }))
      .filter((e) => Number.isFinite(e.area_id))
      .sort((a, b) => b.area_id - a.area_id);

    const sortedvals = entries
      .map((e) => ({
        ...e,
        order: e.key === "Net" ? Number.MAX_SAFE_INTEGER : 0,
      }))
      .sort((a, b) => a.order - b.order)
      .map((e) => ({ key: e.key, area_name: e.area_name, area_id: e.area_id }));

    // Wave-on-wave diffs
    let diffEntries = [];
    if (prevRow) {
      diffEntries = displayKeys
        .map((k) => {
          const curr = Number(row[k]);
          const prev = Number(prevRow[k]);
          const diff = Number.isFinite(curr) && Number.isFinite(prev) ? curr - prev : null;
          return { key: k, area_name: labels[k] || k, area_id: diff };
        })
        .filter((e) => e.area_id !== null);
    }

    const diffSorted = diffEntries
      .map((e) => ({
        ...e,
        order: e.key === "Net" ? Number.MAX_SAFE_INTEGER : 0,
      }))
      .sort((a, b) => a.order - b.order)
      .map((e) => ({ key: e.key, area_name: e.area_name, area_id: e.area_id }));

    // Past vote normalised values
    let pastVoteValues = {};
    const sum = pastVoteCols.reduce((acc, col) => acc + (parseFloat(row?.[col]) || 0), 0);
    if (sum > 0) {
      pastVoteValues = Object.fromEntries(
        pastVoteCols.map((col) => [col, ((parseFloat(row?.[col]) || 0) / sum) * 100])
      );
    }

    return {
      ...f,
      properties: {
        ...f.properties,
        fillColor,
        topKey,
        topLabel,
        topValue,
        _allValues: Object.fromEntries(entries.map((e) => [e.key, e.area_name, e.area_id])),
        _allValuesSorted: sortedvals,
        Turnout: row?.turnout_1_p,
        _diffValues: Object.fromEntries(diffEntries.map((e) => [e.key, e.area_name, e.area_id])),
        _diffValuesSorted: diffSorted,
        _diffTurnout:
          prevRow && row?.turnout_1_p != null && prevRow?.turnout_1_p != null
            ? Number(row.turnout_1_p) - Number(prevRow.turnout_1_p)
            : null,
        _hasPrevWave: !!prevRow,
        ...pastVoteValues,
      },
    };
  };

  /// FIRST DO EVERYTHING FOR THE NORMAL MAP

  const styled = {
    type: "FeatureCollection",
    features: geoData.features.map((f) => {
      const rid = String(f.properties?.area_id ?? "");
      const row = byId.get(rid);
      const prevRow = prevById.get(rid);

      if (!row) {
        return { ...f, properties: { ...f.properties, ...noDataProps } };
      }

      const displayKeys = groupKeys.filter((k) => k in row);
      if (displayKeys.length === 0) {
        return { ...f, properties: { ...f.properties, ...noDataProps } };
      }

      const entries = displayKeys
        .map((k) => ({ key: k, area_name: labels[k] || k, area_id: Number(row[k]) }))
        .filter((e) => Number.isFinite(e.area_id))
        .sort((a, b) => b.area_id - a.area_id);

      const fillColor = colors[entries[0]?.key] || "#000000";
      const topKey = entries[0]?.key;
      const topLabel = entries[0]?.area_name || "";
      const topValue = entries[0]?.area_id || 0;

      return buildFeatureProps(f, row, prevRow, fillColor, topKey, topLabel, topValue);
    }),
  };

  //// NOW REPEAT FOR THE HEAT MAP

  const heatKey = this.state.chosenHeatParty;

  // Build scale from ALL waves so colours are consistent when switching waves
  const allWaveValues = normalisedRows.map((row) => {
    if (this.state.chosenHeatStyle === "pred") {
      if (heatKey === "coalition") {
        return Number(row["nat_pred_n"]) + Number(row["act_pred_n"]) + Number(row["nzf_pred_n"]);
      } else {
        return Number(row[heatKey]);
      }
    } else {
      if (heatKey === "coalition") {
        return (
          Number(row["nat_pred_n"]) + Number(row["act_pred_n"]) + Number(row["nzf_pred_n"]) -
          (Number(row["past_vote_nat"]) + Number(row["past_vote_act"]) + Number(row["past_vote_nzf"]))
        );
      } else {
        return Number(row[heatKey]) - Number(row[PAST_VOTE_MAP[heatKey]]);
      }
    }
  });

  const base = colors[heatKey] || "#6e6e6e";
  const heatScale =
    this.state.chosenHeatStyle === "change"
      ? make2pointHeatScale("#2E7D32", "#C62828", allWaveValues)
      : makeHeatScale(base, allWaveValues);

  const styledHeatMap = {
    type: "FeatureCollection",
    features: geoData.features.map((f) => {
      const rid = String(f.properties?.area_id ?? "");
      const row = byId.get(rid);
      const prevRow = prevById.get(rid);

      if (!row) {
        return { ...f, properties: { ...f.properties, ...noDataProps } };
      }

      const displayKeys = groupKeys.filter((k) => k in row);
      if (displayKeys.length === 0) {
        return { ...f, properties: { ...f.properties, ...noDataProps } };
      }

      const entries = displayKeys
        .map((k) => ({ key: k, area_name: labels[k] || k, area_id: Number(row[k]) }))
        .filter((e) => Number.isFinite(e.area_id))
        .sort((a, b) => b.area_id - a.area_id);

      let v;
      if (this.state.chosenHeatStyle === "pred") {
        if (heatKey === "coalition") {
          v = Number(row["nat_pred_n"]) + Number(row["act_pred_n"]) + Number(row["nzf_pred_n"]);
        } else {
          v = Number(row[heatKey]);
        }
      } else {
        if (heatKey === "coalition") {
          v =
            Number(row["nat_pred_n"]) + Number(row["act_pred_n"]) + Number(row["nzf_pred_n"]) -
            (Number(row["past_vote_nat"]) + Number(row["past_vote_act"]) + Number(row["past_vote_nzf"]));
        } else {
          v = Number(row[heatKey]) - Number(row[PAST_VOTE_MAP[heatKey]]);
        }
      }

      const fillColor = heatScale(v);
      const topKey = heatKey;
      const topLabel = entries[0]?.area_name || "";
      const topValue = Number.isFinite(v) ? v : 0;

      return buildFeatureProps(f, row, prevRow, fillColor, topKey, topLabel, topValue);
    }),
  };

  this.setState({ styledGeo: styled, styledGeoHeatMap: styledHeatMap, styleLoaded: true });
};


  fitBoundsFromFeatures = (features) => {
  if (!this.mapRef1.current || !features?.length) return null;
  const map1 = this.mapRef1.current.getMap();
  const map2 = this.mapRef2.current.getMap();
  const bounds = new mapboxgl.LngLatBounds();
  this.setState({viewState:null})
  features.forEach(f => {
    const coords = f.geometry.type === "Polygon"
      ? f.geometry.coordinates.flat(1)
      : f.geometry.coordinates.flat(2);
    coords.forEach(([lng, lat]) => bounds.extend([lng, lat]));
  });
  map1.fitBounds(bounds, { padding: 80, duration: 500 });
  map2.fitBounds(bounds, { padding: 80, duration: 500 });
  return bounds;
};

  

   onMapClick = (evt) => {
    const feature = evt.features?.[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map1 = this.mapRef1.current?.getMap();
    const map2 = this.mapRef1.current?.getMap();



    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);

    

    const clickedLevel = level;

    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map1?.fitBounds(this.state.selectedStateBounds, { padding: 80, duration: 500 });
          map2?.fitBounds(this.state.selectedStateBounds, { padding: 80, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }

     if (level === "constituency") {
      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateBounds = zoomToFeature(feature); // sets map to state
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "SA3",
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "constituency",
            key: "STATEFP",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("SA3",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("SA3", { doFit: false });
                
  
        }
      );
      return;
    }


  };

    onMouseMove = (evt) => {
        const feature = evt.features && evt.features[0];
        if (!feature) return this.setState({ hoverInfo: null,hoverAreaId:null });
    
        const { lng, lat } = evt.lngLat; 
        this.setState({
        hoverInfo: { lon: lng, lat, props: feature.properties },
        hoverAreaId: feature.properties.area_id ?? null
        });
    };

  loadGeo = async (level) => {
    let newGeo 
    switch(level){
        case "constituency":
         newGeo = this.props.constituencyMap
        break
        case "SA3":
         newGeo = this.props.SA3Map
        break
        case "SA2":
         newGeo = this.props.SA2Map
        break
        default:
         newGeo = this.props.constituencyMap
        break
    }
    this.setState({geoData: newGeo, geoLevel: level
    })
  }

 onGeoLevelChange = (newLevel) => {
  if (!newLevel) return;

  // if these are async functions already, await them
  this.fetchMetrics(newLevel, this.state.selectedFeature?.area_id);
  this.loadGeo(newLevel);

  // return when both finish
};
    // Utility: compute bounds [minX, minY, maxX, maxY] from a FeatureCollection
getFeatureCollectionBounds = (featureCollection) => {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

  featureCollection.features.forEach((feat) => {
    const coords = feat.geometry.coordinates;

    const recurse = (arr) => {
      if (typeof arr[0] === "number") {
        const [x, y] = arr;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      } else {
        arr.forEach(recurse);
      }
    };

    recurse(coords);
  });

  return [[minX, minY], [maxX, maxY]];
};
    

   resetView = ({ LevelToResetTo = "constituency" }) => {
    const map1 = this.mapRef1.current?.getMap();
    const map2 = this.mapRef2.current?.getMap();
      if (map1) {
    map1.fitBounds(
      [
        [166.0, -47.5], // SW
        [179.0, -33.0], // NE
      ],
      { padding: 80 }
    );
  }
   if (map2) {
    map2.fitBounds(
      [
        [166.0, -47.5], // SW
        [179.0, -33.0], // NE
      ],
      { padding: 80 }
    );
  }

  this.setState(
    {
      geoLevel: LevelToResetTo,
      selectedStateCode: null,
      selectedStateBounds: null,
      selectedFeature: null,
      metricRows: null,
      styledGeo: null,
      
    },
    () => {
      this.onGeoLevelChange(LevelToResetTo);

    }
  );
};

handleselectedFeatureChange =  (area_id, area_name) => {



    const feature = this.props.constituencyMap.features.filter(
          f => String(f.properties.area_id) === String(area_id.area_id)
        )[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map1 = this.mapRef1.current?.getMap();
    const map2= this.mapRef2.current?.getMap();

    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);   

    const clickedLevel = level;


    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map1?.fitBounds(this.state.selectedStateBounds, { padding: 80, duration: 500 });
          map2?.fitBounds(this.state.selectedStateBounds, { padding: 80, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }
      const stateBounds = zoomToFeature(feature); // sets map to state

      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "SA3",
          viewState:null,
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "constituency",
            key: "area_id",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
            
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("SA3",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("SA3", { doFit: false });
                
  
        }
      );
      return;
    

    
}

 handlechosenGenderChange     = (val) => this.setState({ chosenGender: val });
 handlechosenAgeChange     = (val) => this.setState({ chosenAge: val });
 handlechosenEthnicityChange     = (val) => this.setState({ chosenEthnicity: val });
 handlechosenEducationChange     = (val) => this.setState({ chosenEducation: val });
 handlechosenPVChange     = (val) => this.setState({ chosenPV: val });
 handlechosenHeatPartyChange     = (val) => this.setState({ chosenHeatParty: val });
 handlechosenHeatStyleChange     = (val) => this.setState({ chosenHeatStyle: val });
     handlewaveSelectChange     = (val) => {
    
    this.setState({ waveSelect: val })
    
  };
   

  render() {
  const heatPartyOptions = heatPartyOptionsFor(this.props.access);

  return(
    
    <>
    <Box
    width="100%"
  sx={{
    display: "grid",
    gridTemplateColumns: "0.15fr 0.60fr 0.25fr",
    gap: 2, // optional
    height:"100%"
  }}
>
  <Box>     
     <Stack direction="column"  alignItems="left" sx={{ ml: 4, mt:10 }}>

        
          <Typography variant="h5" fontWeight={700}>Voter Breakdown</Typography>
          <Typography variant="body1" color="text.secondary" sx={{mt:2}}>
            Use this view to build and visualise your own voter profiles. You can use the filters below to construct your voter, then drill down into different seats by selecting an Electorate.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{mt:15}}>
            Build a voter profile:
          </Typography>
          <TextField
                select
                label="Gender"
                size="small"
                value={this.state.chosenGender}
                onChange={(e) => this.handlechosenGenderChange?.(e.target.value)}
                sx={{ mt: 3, minWidth: 180 }}
                >
                <MenuItem value={null}>All</MenuItem>
                <MenuItem value="M">Male</MenuItem>
                <MenuItem value="F">Female</MenuItem>
                </TextField>

                <TextField
                select
                label="Age"
                size="small"
                value={this.state.chosenAge}
                onChange={(e) => this.handlechosenAgeChange?.(e.target.value)}
                sx={{ mt: 3, minWidth: 180 }}
                >
                <MenuItem value={null}>All</MenuItem>
                <MenuItem value="Young">Young</MenuItem>
                <MenuItem value="Middle">Middle</MenuItem>
                <MenuItem value="Old">Old</MenuItem>
                </TextField>

                
                <TextField
                select
                label="Education"
                size="small"
                value={this.state.chosenEducation}
                onChange={(e) => this.handlechosenEducationChange?.(e.target.value)}
                sx={{ mt: 3, minWidth: 180 }}
                >
                <MenuItem value={null}>All</MenuItem>
                <MenuItem value="High">High</MenuItem>
                <MenuItem value="Mid">Mid</MenuItem>
                <MenuItem value="Low">Low</MenuItem>
                </TextField>

                <TextField
                select
                label="Ethnicity"
                size="small"
                value={this.state.chosenEthnicity}
                onChange={(e) => this.handlechosenEthnicityChange?.(e.target.value)}
                sx={{ mt: 3, minWidth: 180 }}
                >
                <MenuItem value={null}>All</MenuItem>
                <MenuItem value="Asian only">Asian only</MenuItem>
                <MenuItem value="European only">European only</MenuItem>
                <MenuItem value="European/Māori">European/Māori</MenuItem>
                <MenuItem value="Māori only">Māori only</MenuItem>
                <MenuItem value="Pacific Peoples only">Other</MenuItem>
                </TextField>

                {/* <TextField
                select
                label="2023 Vote"
                size="small"
                value={this.state.chosenPV}
                onChange={(e) => this.handlechosenPVChange?.(e.target.value)}
                sx={{ mt: 3, minWidth: 180 }}
                >
                <MenuItem value={null}>All</MenuItem>
                <MenuItem value="ACT">ACT 2023</MenuItem>
                <MenuItem value="GREEN">Green 2023</MenuItem>
                <MenuItem value="LAB">Labour 2023</MenuItem>
                <MenuItem value="NAT">National 2023</MenuItem>
                <MenuItem value="NZF">NZF 2023</MenuItem>
                <MenuItem value="TPM">TPM 2023</MenuItem>
               <MenuItem value="OTH">Other 2023</MenuItem>
                <MenuItem value="DNV">Did not vote</MenuItem>
                </TextField> */}

                <TextField
                      select
                      label="Wave"
                      size="small"
                      value={this.state.waveSelect}
                      onChange={(e) => this.handlewaveSelectChange?.(e.target.value)}
                      sx={{ mt: 3, minWidth: 180 }}
                    >
                     
                      {this.state.waveOptions?.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>

                <DownloadMetricRowsButton metricrows={this.state.metricRows} />

       </Stack>
    </Box>
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",     // make sure this column fills available height
            }}
            >
             <Stack direction="column"  alignItems="left" sx={{ mt:10 }}>

        
          <Typography variant="h5" fontWeight={700}>Winning Party</Typography>
          <Typography variant="body1" color="text.secondary" sx={{mt:2}}>
            Select an Electorate from the drop-down menu,or click on a block below to zoom in on the map
          </Typography>
          </Stack>

            <Box
                sx={{
                mt: "auto",       // pushes this box to the bottom
                height: "100%",    // give it a height
                mb:1,
                display: "flex",
                alignContent:"center",
                justifyContent:"center",
                alignItems:"center",
                justifyItems:"center"
                }}
            >
          
              <MapComponent
                mapRef={this.mapRef1}
                styledGeo={this.state.styledGeo}
                geoData={this.state.geoData}
                hoverInfo={this.state.hoverInfo}
                styleLoaded={this.state.styleLoaded}
                selectedFeature={this.state.selectedFeature}
                onMapClick={this.onMapClick}
                onMouseMove={this.onMouseMove}
                onGeoLevelChange={this.onGeoLevelChange}
                buildLabelsAndColors={buildLabelsAndColors}
                geoLevel={this.state.geoLevel}
                resetView={this.resetView}
                handleselectedFeatureChange={this.handleselectedFeatureChange}
                viewState={this.state.viewState}
                tooltip = {"home"}
                tooltip_pastcomp="no"
                />
                 {this.state.loading && (
                                     <Box
                                     sx={{
                                         position: "absolute",
                                         inset: 0,
                                         display: "flex",
                                         alignItems: "center",
                                         justifyContent: "center",
                                         backgroundColor: "rgba(255, 255, 255, 0.6)", // semi-transparent overlay
                                         zIndex: 10,
                                     }}
                                     >
                                     <CircularProgress />
                                     </Box>
                   )}
                
               
            </Box>
            </Box>
            <Box>
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",     // make sure this column fills available height
                px:1,
                py:1 ,   
                 justifyContent: "flex-end", // push everything to the bottom
            }}
            >
              <Stack direction="column" alignItems="flex-start" sx={{ mb: 2 }} width="100%">
                    <Typography variant="h5" fontWeight={700}>Vote Shares</Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
                    {heatPartyOptions.length > 1
                      ? "Select a party to display their vote shares on the heat map"
                      : `Vote shares for ${heatPartyOptions[0]?.label ?? "your party"} on the heat map`}
                    </Typography>
                     <Stack direction="row" alignItems="flex-start" sx={{ mb: 2 }} width="100%">

                     {heatPartyOptions.length > 1 && (
                     <FormControl size="small" sx={{ mt:2,mb:1, minWidth: 180 }}> 
                      <Select //labelId="pv-label" 
                     //label="pv" 
                      value={this.state.chosenHeatParty} 
                      onChange={(e) => this.handlechosenHeatPartyChange?.(e.target.value)} >
                                      {heatPartyOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                          {option.label}
                                        </MenuItem>
                                      ))}
                               </Select> 
                         </FormControl>
                     )}

                    <FormControl size="small" sx={{ mt:2,mb:1, minWidth: 180 }}> 
                      <Select //labelId="pv-label" 
                     //label="pv" 
                      value={this.state.chosenHeatStyle} 
                      onChange={(e) => this.handlechosenHeatStyleChange?.(e.target.value)} >
                                      <MenuItem value="pred">Predicted Vote Share</MenuItem>
                                      <MenuItem value="change">Change Since 2023</MenuItem>
                               </Select> 
                         </FormControl>
                         </Stack>
                    <NationalVoteBar
                        metricRowsConst={this.state.metricRows}
                        metricRowsNat={this.state.metricRowsNational}
                        selectedFeature={this.state.selectedFeature}
                         WIDTH={"100%"}
                         latest_wave = {this.state.waveSelect}
                         filt="filt"
                    />   
                </Stack>

            <Box
                sx={{
                height: "50%",    // give it a height
                display: "flex",
                alignContent:"center",
                justifyContent:"center",
                alignItems:"center",
                justifyItems:"center"
                }}
            >
                    
                <MapComponent
                mapRef={this.mapRef2}
                styledGeo={this.state.styledGeoHeatMap}
                geoData={this.state.geoData}
                hoverInfo={this.state.hoverInfo}
                styleLoaded={this.state.styleLoaded}
                selectedFeature={this.state.selectedFeature}
                onMapClick={this.onMapClick}
                onMouseMove={this.onMouseMove}
                onGeoLevelChange={this.onGeoLevelChange}
                buildLabelsAndColors={buildLabelsAndColors}
                geoLevel={this.state.geoLevel}
                resetView={this.resetView}
                handleselectedFeatureChange={this.handleselectedFeatureChange}
                viewState={this.state.viewState}
                tooltip="seatcomp"
                tooltip_pastcomp="no"
                smallMap="yes"
            chosenParty = {this.state.chosenHeatParty}
            chosenView={"pred"}
                />   
                
                    {this.state.loading && (
                                     <Box
                                     sx={{
                                         position: "absolute",
                                         inset: 0,
                                         display: "flex",
                                         alignItems: "center",
                                         justifyContent: "center",
                                         backgroundColor: "rgba(255, 255, 255, 0.6)", // semi-transparent overlay
                                         zIndex: 10,
                                     }}
                                     >
                                     <CircularProgress />
                                     </Box>
                   )}
            </Box>

            
        </Box>

 
    </Box>
    </Box>

</>

  )
}


  }

export default withRouter(withAccess(NZ2026Home));